import { useEffect, useRef, useState } from "react";
import CitationComponent from "./citation-component";
import { Button, ButtonProps } from "../../../button";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { CitationComponent as TCitationComponent } from "@aichat/types/socket/widget.types";

type CitationListProps = {
  citations: TCitationComponent[];
};
function CitationList({ citations }: CitationListProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [showLeftChevron, setShowLeftChevron] = useState(false);
  const [showRightChevron, setShowRightChevron] = useState(false);

  useEffect(() => {
    const updateChevrons = () => {
      if (ref.current) {
        const { scrollLeft, scrollWidth, clientWidth } = ref.current;
        setShowLeftChevron(scrollLeft > 0);
        setShowRightChevron(scrollLeft + clientWidth < scrollWidth);
      }
    };

    // Add event listener to the scrollable element
    const scrollElement = ref.current;
    scrollElement?.addEventListener("scroll", updateChevrons);

    // Initial update to set the chevrons correctly
    updateChevrons();

    // Clean up the event listener on unmount
    return () => {
      scrollElement?.removeEventListener("scroll", updateChevrons);
    };
  }, []);

  function onChevronClick(direction: "left" | "right" = "right") {
    if (ref.current) {
      const { clientWidth } = ref.current;
      const scrollAmount = direction === "left" ? -clientWidth : clientWidth;
      ref.current.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });
    }
  }

  return (
    <div className="relative">
      {showLeftChevron && (
        <div className="absolute z-20 top-1/2 -translate-y-1/2 left-2">
          <ChevronBtnWrapper
            onClick={() => {
              onChevronClick("left");
            }}
          >
            <ChevronLeft />
          </ChevronBtnWrapper>
        </div>
      )}
      {showRightChevron && (
        <div className="absolute z-20 top-1/2 -translate-y-1/2 right-2">
          <ChevronBtnWrapper
            onClick={() => {
              onChevronClick("right");
            }}
          >
            <ChevronRight />
          </ChevronBtnWrapper>
        </div>
      )}
      <div
        ref={ref}
        className="flex-1 relative whitespace-nowrap overflow-auto no-scrollbar"
      >
        <div className="flex gap-2 pb-3">
          {citations.map((citation) => (
            <CitationComponent {...citation} />
          ))}
        </div>
      </div>
    </div>
  );
}

function ChevronBtnWrapper(props: ButtonProps) {
  return (
    <Button
      className="size-7 p-0 rounded-full bg-background/80 hover:bg-background-100 shadow"
      {...props}
    />
  );
}

export default CitationList;
